import {
  Button,
  Card,
  Table,
  Space,
  notification,
  Form,
  Input,
} from "antd";
import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { GET } from "../../utils/apicalls";
import LoadingAnimation from "../../componets/loader/loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import "./BookingData.css";
function Bookingdata() {
  const [data, setData] = useState<any[]>([]);
  const [clientData, setClientData] = useState<any[]>([]);
  const [productData, setProductData] = useState<any[]>([]);
  const [variantData, setVariantData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [form] = Form.useForm();

  // 🧠 Fetch carts
  const fetchCartWiseData = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.GET_ALL_CARTS, {});
      console.log("🛒 Cart Data:", response);
      if (Array.isArray(response)) {
        const updated = response.map((cart) => {
          const total = cart.CartItems?.reduce((sum: number, item: any) => {
            const price =
              item?.unitPrice ||
              item?.variant?.variantprice ||
              item?.price ||
              0;
            return sum + price * (item?.quantity || 1);
          }, 0);
          return { ...cart, totalAmount: total };
        });
        setData(updated);
        setFilteredData(updated);
      }
    } catch (e) {
      console.error("Cart Fetch Error:", e);
      notification.error({ message: "Failed to load cart data" });
    } finally {
      setIsLoading(false);
    }
  };

  // 🧠 Fetch client data
  const fetchClient = async () => {
    try {
      const res: any = await GET(API.GET_LISTING_CLIENT_DATA, {});
      setClientData(res?.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  // 🧠 Fetch products and variants together
  const fetchProductsAndVariants = async () => {
    try {
      const prodRes: any = await GET(API.PRODUCT_GET_LISTING, {});
      const products = prodRes?.data || [];
      setProductData(products);

      const allVariants: any[] = [];
      for (const product of products) {
        const res: any = await GET(`${API.GET_BY_PRODUCTID_VARIANT}${product.id}`, {});
        const arr =
          Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
        arr.forEach((v: any) => {
          allVariants.push({ ...v, productId: product.id });
        });
      }
      console.log("🧩 All Variants:", allVariants);
      setVariantData(allVariants);
    } catch (e) {
      console.error("Variant Fetch Error:", e);
    }
  };

  useEffect(() => {
    fetchClient();
    fetchProductsAndVariants();
    fetchCartWiseData();
  }, []);

  // 🧩 Get Variant Name
  const getVariantName = (item: any) => {
    // If variant object exists directly
    if (item?.variant?.variantName) return item.variant.variantName;

    // If variantId matches fetched list
    const byId = variantData.find((v: any) => v.id === item.variantId);
    if (byId?.variantName) return byId.variantName;

    // If productId matches, but variantId missing (single variant product)
    const byProduct = variantData.find((v: any) => v.productId === item.productId);
    if (byProduct?.variantName) return byProduct.variantName;

    return "-";
  };
  const downloadCartPDF = (cart: any) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("CART BOOKING RECEIPT", 15, 15);

    doc.setFontSize(10);

    const booking = cart.bookingData;

    // LEFT SIDE DETAILS
    let leftY = 30;

    doc.text(`Cart ID: ${cart.id}`, 15, leftY); leftY += 5;
    doc.text(`Buyer: ${booking?.Buyername || "-"}`, 15, leftY); leftY += 5;
    doc.text(`Email: ${booking?.Buyeremail || "-"}`, 15, leftY); leftY += 5;
    doc.text(`Mobile: ${booking?.Buyermobile_number || "-"}`, 15, leftY); leftY += 5;

    // WRAP ADDRESS (THIS FIXES THE CUT TEXT)
    const address = booking?.Buyeraddress || "-";
    const wrappedAddress = doc.splitTextToSize(address, 80); // 80px width
    doc.text("Address:", 15, leftY);
    doc.text(wrappedAddress, 35, leftY);
    leftY += wrappedAddress.length * 5 + 2;

    // RIGHT SIDE DETAILS
    const pageWidth = doc.internal.pageSize.getWidth();
    const rightX = pageWidth - 80;

    doc.text(
      `Order Date: ${booking?.createdAt
        ? moment(booking.createdAt).format("DD/MM/YYYY")
        : "-"
      }`,
      rightX,
      30
    );

    doc.text(`Total Amount: ₹${cart.totalAmount}`, rightX, 37);

    // TABLE
    autoTable(doc, {
      startY: leftY + 5,
      head: [["Product", "Variant", "Partner", "Qty", "Price", "Subtotal"]],
      body: cart.CartItems.map((item: any) => {
        const product = productData.find((p) => p.id === item.productId);
        const variantName = getVariantName(item);
        const client = clientData.find((c) => c.id === item.partnerId);
        const partner = client?.clientName || "Admin";

        const price =
          item?.unitPrice ||
          item?.variant?.variantprice ||
          item?.price ||
          0;
        const subtotal = price * (item?.quantity || 1);

        return [
          product?.productTitle || "-",
          variantName,
          partner,
          item?.quantity || 1,
          `${price}`,
          `${subtotal}`,
        ];
      }),
      theme: "grid",
    });

    doc.save(`Cart_${cart.id}.pdf`);
  };

  // 🧩 Expanded Table for Cart Items
  const ExpandedRow = ({ cart }: { cart: any }) => {
    const columns = [
      {
        title: "Product Name",
        render: (_: any, r: any) => {
          const p = productData.find((c) => c.id === r.productId);
          return p?.productTitle || "-";
        },
      },
      {
        title: "Variant",
        render: (_: any, r: any) => getVariantName(r),
      },
      {
        title: "Partner",
        render: (_: any, r: any) => {
          const c = clientData.find((x) => x.id === r.partnerId);
          return c?.clientName || "Admin";
        },
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        align: "center" as const,
      },
      {
        title: "Price (₹)",
        align: "center" as const,
        render: (_: any, r: any) =>
          r?.unitPrice ||
          r?.variant?.variantprice ||
          r?.price ||
          "-",
      },
      {
        title: "Subtotal (₹)",
        align: "center" as const,
        render: (_: any, r: any) => {
          const price =
            r?.unitPrice || r?.variant?.variantprice || r?.price || 0;
          const subtotal = price * (r?.quantity || 1);
          return `₹${subtotal}`;
        },
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={cart.CartItems}
        pagination={false}
        rowKey={(i) => i.id}
      />
    );
  };

  // 🧩 Filter Logic
  const handleFilter = (values: any) => {
    const search = values?.Buyername?.toLowerCase() || "";
    const filtered = data.filter((item: any) =>
      item?.bookingData?.Buyername?.toLowerCase()?.includes(search)
    );
    setFilteredData(filtered);
  };

  const handleReset = () => {
    form.resetFields();
    setFilteredData(data);
  };

  const columns = [
    {
      title: "Cart ID",
      dataIndex: "id",
      align: "center" as const,
    },
    {
      title: "Buyer",
      render: (_: any, r: any) => r?.bookingData?.Buyername || "-",
      align: "center" as const,
    },
    {
      title: "Email",
      render: (_: any, r: any) => r?.bookingData?.Buyeremail || "-",
      align: "center" as const,
    },
    {
      title: "Mobile",
      render: (_: any, r: any) => r?.bookingData?.Buyermobile_number || "-",
      align: "center" as const,
    },
    {
      title: "Total Amount (₹)",
      dataIndex: "totalAmount",
      align: "center" as const,
      render: (v: any) => `₹${v?.toLocaleString() || 0}`,
    },
    {
      title: "Actions",
      align: "center" as const,
      render: (_: any, r: any) => (
        <Button type="link" onClick={() => downloadCartPDF(r)}>
          Download PDF
        </Button>
      ),
    },
  ];

  return (
    <div style={{ overflowX: "hidden" }}>
      {isLoading ? (
        <LoadingAnimation />
      ) : (
        <div className="container booking-container">
          <h2 className="page-title">CART-WISE BOOKING DATA</h2>

          <Card className="filter-card">
            <Form
              form={form}
              layout="vertical"
              onFinish={handleFilter}
              className="filter-form"
            >
              <div className="filter-grid">
                <Form.Item name="Buyername" label="Buyer Name" className="filter-item">
                  <Input placeholder="Enter Buyer Name" />
                </Form.Item>

                <div className="filter-buttons">
                  <Button type="primary" htmlType="submit" block>
                    Filter
                  </Button>

                  <Button onClick={handleReset} block style={{ marginTop: 8 }}>
                    Reset
                  </Button>
                </div>
              </div>
            </Form>
          </Card>

          <Card>
            <Table
              columns={columns}
              dataSource={filteredData}
              expandable={{
                expandedRowRender: (r) => (
                  <div style={{ overflowX: "auto" }}>
                    <ExpandedRow cart={r} />
                  </div>
                ),
              }}
              rowKey={(r) => r.id}
              pagination={{ pageSize: 5 }}
              scroll={{ x: "max-content" }}
            />
          </Card>
        </div>
      )}
    </div>
  );

}

export default Bookingdata;
